module.exports = __webpack_public_path__ + "fonts/EuclidFlex-Light.9f49bec.otf";